// Constants for App Migration Feature

import { IAppMigrationConfig, IBannerDismissConfig } from './types';

// Experiment Configuration
export const APP_MIGRATION_EXP = 'app-migration';
export const APP_MIGRATION_EXP_VARIANT_A = 'app-migration-a';
export const APP_MIGRATION_EXP_VARIANT_B = 'app-migration-b';

// AppsFlyer OneLink Configuration
export const APPSFLYER_CONFIG: IAppMigrationConfig = {
  // New OneLink URL provided by product manager
  oneLinkURL: 'https://nykaafashion.onelink.me/qByN',

  // Media source - picks from utm_source or defaults to 'mweb'
  mediaSource: {
    keys: ['utm_source'],
    defaultValue: 'mweb',
  },

  // Custom parameters for attribution tracking
  customParams: [
    {
      paramKey: 'utmCampaign',
      keys: ['utmCampaign'],
      defaultValue: 'mweb_to_app',
    },
    {
      paramKey: 'utmMedium',
      keys: ['utmMedium'],
    },
    {
      paramKey: 'utmContent',
      keys: ['utmContent'],
    },
    {
      paramKey: 'trackingCode',
      keys: ['variantID'],
    },
    {
      paramKey: 'af_ss_ui',
      defaultValue: 'true',
    },
  ],
};

// AppsFlyer Smart Script CDN URL
export const APPSFLYER_SMART_SCRIPT_URL =
  'https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js';

// Banner dismiss configuration (floating banner / bottom sheet — localStorage)
export const BANNER_DISMISS_CONFIG: IBannerDismissConfig = {
  storageKey: 'app_migration_banner_dismissed',
  dismissDurationMs: 24 * 60 * 60 * 1000, // 24 hours
};

/**
 * Top sticky banner dismiss — Redux session state only (see store/appMigration).
 * Hard refresh resets dismiss so SSR always paints the banner when eligible (no CLS).
 */

// App install detection cache configuration
export const APP_INSTALL_CACHE_CONFIG = {
  storageKey: 'app_migration_app_installed',
  cacheDurationMs: 24 * 60 * 60 * 1000, // 24 hours
};

// CTA Text options
export const CTA_TEXT = {
  USE_APP: 'Use App' as const,
  DOWNLOAD_APP: 'Download App' as const,
  DOWNLOAD_NOW: 'Download Now' as const,
};

// Banner text content
export const BANNER_TEXT = {
  LINE_1: 'Download',
  LINE_2: 'App NOW',
};

// Android app package names to check
// com.fsn.nds is the package ID in manifest.json (Nykaa Design Studio / Nykaa Fashion)
export const ANDROID_APP_PACKAGES = ['com.fsn.nds', 'com.nykaa.fashion'];

// App store URLs (fallback)
export const STORE_URLS = {
  PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.fsn.nds',
  APP_STORE: 'https://apps.apple.com/in/app/nykaa-fashion/id1419578103',
};

// Nykaa Fashion logo URL for banner
export const NYKAA_FASHION_LOGO_URL =
  'https://images-static.nykaa.com/nykdesignstudio-images/pub/media/nf-app-icon.png';

// Default inline banner background image URL (S3)
export const INLINE_BANNER_IMAGE_URL =
  'https://images-static.nykaa.com/nykdesignstudio-images/pub/media/fashion-images/inlineBanner.png';
